import { useEffect, useRef } from 'react';
import { telemetryManager } from '@repo/runtime-kit/utils/telemetry-manager';
import { useDeferredCleanupEffect } from './use-deferred-cleanup-effect';

interface UseReadinessSpanArgs {
  isLoading: boolean;
  isError: boolean;
  error?: unknown;
  attributes?: Record<string, unknown>;
}

export function useReadinessSpan(name: string, args: UseReadinessSpanArgs): void {
  const { isLoading, isError, error, attributes } = args;
  const endedRef = useRef(false);
  const attributesRef = useRef(attributes);
  attributesRef.current = attributes;

  useDeferredCleanupEffect(
    () => {
      telemetryManager.startUiReadiness(name);
    },
    () => {
      if (endedRef.current) return;
      telemetryManager.endUiReadiness(name);
      endedRef.current = true;
    }
  );

  useEffect(() => {
    // oxlint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
    if (endedRef.current || isLoading) return;
    telemetryManager.endUiReadiness(
      name,
      isError
        ? { status: 'error', exception: error, attributes: attributesRef.current }
        : { status: 'ok', attributes: attributesRef.current }
    );
    endedRef.current = true;
  }, [name, isLoading, isError, error]);
}
